import { PropertyDataFire } from './components';

export const StepThree = () => <PropertyDataFire />;
